import { render, staticRenderFns } from "./GameIcon.vue?vue&type=template&id=2aa38332"
import script from "./GameIcon.vue?vue&type=script&lang=js"
export * from "./GameIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports